// extracted by mini-css-extract-plugin
export default {"create-modal-form":"UpgradeDomainModal_create-modal-form__mxzVL","rules":"UpgradeDomainModal_rules__Azwce","submit-buttons":"UpgradeDomainModal_submit-buttons__xjQne"};